export default "__VITE_ASSET__Cop0L3LZ__"